import React, {useEffect, useState} from "react";
import {Icon28CupOutline} from "@vkontakte/icons";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {getJoinableTournamentsCount} from "../../services/tournament";
import {parseLaunchParams} from "../../utils/launch_params";
import {isCatalogPreview} from "../../utils/catalogPreview";

const READY_BADGE_CLASSES = "arcade-badge !absolute !top-2 !right-2 min-w-[24px]";

// Баннер, ведущий к отдельной панели турниров, оформленный в стиле остальных карточек.
export default function TournamentBanner() {
    const catalogPreview = isCatalogPreview();
    const routeNavigator = useRouteNavigator();
    // Храним количество турниров, доступных для вступления.
    const [joinableCount, setJoinableCount] = useState(0);

    const handleClick = () => routeNavigator.push('/tournaments');

    useEffect(() => {
        // Режим каталога показывает доступные турниры без данных запуска VK.
        if (catalogPreview) {
            setJoinableCount(3);
            return;
        }
        // Загружаем количество доступных турниров для бейджа.
        const params = parseLaunchParams();
        if (!params.vk_user_id) {
            setJoinableCount(0);
            return;
        }

        getJoinableTournamentsCount().then(resp => {
            const count = resp.data?.response?.count ?? 0;
            setJoinableCount(Number.isFinite(count) ? count : 0);
        }).catch(err => {
            console.error("tournament banner load error", err);
            setJoinableCount(0);
        });
    }, []);

    return (
        <div className="w-full cursor-pointer" onClick={handleClick}>
            <div className="arcade-panel p-4 space-y-4 relative">
                <div className="flex items-center gap-3">
                    <div className="arcade-icon-frame w-12 h-12 flex-shrink-0 flex items-center justify-center">
                        <Icon28CupOutline/>
                    </div>
                    <div className={" text-gray-800"}>
                        <p className="arcade-title text-base font-black">Турниры</p>
                        <p className="text-sm">Соревнуйтесь за призы ежедневно и еженедельно</p>
                    </div>
                </div>
                {joinableCount > 0 && (
                    <span className={READY_BADGE_CLASSES}>{joinableCount}</span>
                )}
            </div>
        </div>
    );
}
